import React from "react"
import { pick } from "lodash"

const flexItem = (props) => {
  let style = pick(props.style, [
    "order",
    "flexGrow",
    "flexShrink",
    "flexBasis",
    "flex",
    "alignSelf",
    "maxWidth",
    "minWidth",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
  ])

  return (
    <div style={style} data-qa={props["data-qa"]}>
      {props.children}
    </div>
  )
}

flexItem.propTypes = {}
flexItem.defaultProps = {}

export default flexItem
